import { createContext } from "react";

const NoteContext = new createContext()

export { NoteContext }